@use 'src/styles/config.module' as *;

.wrapper {
  display: grid;
  grid-template-columns: 23rem 1fr;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.1);
  border-radius: 0.4rem;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;

  .tabsNavWrapper {
    background: $color-grey-light-two;
    position: relative;
    height: 100%;
    width: 100%;
  }

  .tabsNav {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    .link {
      border-top: 1px solid #fff;
      color: $color-default;
      padding: 0.7rem 2rem 0.8rem;
      position: relative;
      line-height: 1.35;
      &:last-child {
        border-bottom: 1px solid #eef0f2;
      }
      &.active {
        color: $color-primary;
        background: #fff;
        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          width: 3px;
          background: $color-primary;
        }
      }
    }
    :global {
      .MuiList-root {
        padding: 1rem 0;
      }
    }
  }

  .content {
    display: flex;
  }

  :global {
    .data-grid {
      box-shadow: none;
      border-radius: 0;
      .toolbar-head {
        padding: 2.8rem 2rem 0.6rem;
        text-transform: capitalize;
      }
      .data-grid__toolbar {
        padding-bottom: 2.2rem;
      }
    }
  }
}
